'use strict';

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require('jquery');
// TODO: v pripade, ze je pouzit linksoft/core/localize, tak za nejakych zatim nezjistenych duvodu se neprovede initializace pro nasledne vytvoreni instance localize()


Dropzone.options.oneFileUploadDropzone = {
	maxFiles: 1,
	dictDefaultMessage: (0, _localize2.default)("App:DragFilesOrClickHere"),
	dictMaxFilesExceeded: (0, _localize2.default)("App:NumberOfUploadedFilesExceeded")
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/main.js
// module id = 1086
// module chunks = 1